<template>
    <div>
        <b-modal id="modal-cost" class="maintenance_modal" centered :footer-class="'d-block p-3 m-0'" scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title"> {{ costData ? $t('safetyCosts.editTitle') : $t('safetyCosts.addTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="d-block text-center">
                <b-row>
                    <b-col sm="12" class="text-left">
                        <b-form-group>
                            <label class="state">{{ $t('safetyCosts.dateLabel') }}</label>
                            <date-picker v-model="costPayload.date" :formatter="momentFormat" :range-separator="' - '"
                                @clear="costPayload.date = ''" :placeholder="$t('safetyShared.selectDate')" class="date-picker-custom"
                                :teleport="'body'" :disabled="!allowUpdateRecord"></date-picker>
                            <p v-if="errors && errors.name" class="field-error">
                                {{ errors.name[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('safetyCosts.descriptionLabel') }}</label>
                            <b-form-textarea id="textarea" :disabled="!allowUpdateRecord" :placeholder="$t('safetyCosts.descriptionPlaceholder')"
                                rows="3" v-model="costPayload.description" class="f-12"></b-form-textarea>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('safetyCosts.amountLabel') }}</label>
                            <b-form-input type="text" v-mask="amountMask" class="f-12" @blur="amountHandler"
                                :placeholder="$t('safetyCosts.amountPlaceholder')" required v-model="costPayload.amount"
                                :disabled="!allowUpdateRecord"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mt-3 mr-3 btn cancel m-0" block @click="resetPopup()">{{ $t('safetyShared.cancel') }}</b-button>
                    <div class="d-flex align-items mt-3 m-0">
                        <b-button class="btn save mx-0 w-100" variant="primary" @click="onAddContact"
                            v-if="allowUpdateRecord">{{ $t('safetyShared.save') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import * as moment from "moment-timezone";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { pickerDate } from "@/services/helper";

const amountMask = createNumberMask({
    prefix: "",
    allowDecimal: true,
    includeThousandsSeparator: true,
});
export default {
    name: "Costs",
    props: ["id", "costData", "addCost", 'updateCost', 'allowUpdateRecord'],
    components: {
        DatePicker
    },
    data() {
        return {
            errors: {},
            amountMask,
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            costPayload: {
                date: "",
                description: "",
                amount: "",
            },
        }
    },
    methods: {
        ...mapActions(['setNotification', 'setLoader']),
        resetPopup() {
            this.errors = {}
            this.costPayload = {
                date: "",
                description: "",
                amount: "",
            }
            this.$emit("popupClose")
            this.$bvModal.hide("modal-cost");
        },
        amountHandler(event) {
            const value = event.target.value;
            if (value && !value.includes('.')) {
                event.target.value = `${value}.00`;
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async onAddContact() {
            try {
                const nullKeys = this.checkNullValues({
                    date: this.costPayload.date
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    let successMsg = this.$t('safetyCosts.costAdded')
                    if (this.costData) {
                        await this.updateCost({
                            id: this.id, payload: {
                                ...this.costPayload, id: this.costData.id, date: moment(this.costPayload.date).format('YYYY-MM-DD'), amount: this.costPayload.amount
                                    ? parseFloat(this.costPayload.amount.replace(/,/g, '')).toFixed(2)
                                    : 0
                            }
                        })
                        successMsg = this.$t('safetyCosts.costUpdated')
                    }
                    else await this.addCost({
                        id: this.id, payload: {
                            ...this.costPayload, date: moment(this.costPayload.date).format('YYYY-MM-DD'), amount: this.costPayload.amount
                                ? parseFloat(this.costPayload.amount.replace(/,/g, '')).toFixed(2)
                                : 0
                        }
                    })
                    await this.setNotification({
                        msg: successMsg,
                        type: "success",
                        color: "green",
                    });
                    this.$emit("costUpdated", true)
                    this.resetPopup()
                    this.setLoader(false)
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('safetyShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false);
            }
        }
    },
    watch: {
        costData() {
            if (this.costData) {
                this.costPayload = {
                    date: pickerDate(this.costData.date),
                    description: this.costData.description,
                    amount: this.costData.amount
                }
            }
        }
    }
}
</script>